import { useTranslation } from 'react-i18next'
import { GoBackButton, Heading } from '@repo/ui'

export default function Impressum() {
  const { t } = useTranslation('common')
  const testIdInit = 'impressum'

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-0.5">
        <GoBackButton data-testid={`${testIdInit}-go-back-button`} />
        <Heading tag="h1">{t('impressum.title')}</Heading>
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex flex-col">
          <span data-testid={`${testIdInit}-consortium-title`}>
            {t('impressum.consortium_title')}
          </span>
        </div>
        <div data-testid={`${testIdInit}-consortium-text`}>
          {t('impressum.consortium_text')}
        </div>
        <div className="flex flex-col">
          <span data-testid={`${testIdInit}-area-title`}>
            {t('impressum.area_title')}
          </span>
          <span data-testid={`${testIdInit}-area`}>{t('impressum.area')}</span>
        </div>
        <div>
          <span className="pr-0.5" data-testid={`${testIdInit}-office-title`}>
            {t('impressum.office_title')}
          </span>
          <span data-testid={`${testIdInit}-office`}>
            {t('impressum.office')}
          </span>
        </div>
        <div>
          <span className="pr-0.5" data-testid={`${testIdInit}-register-title`}>
            {t('impressum.register_title')}
          </span>
          <span data-testid={`${testIdInit}-register`}>
            {t('impressum.register')}
          </span>
        </div>
        <div>
          <span className="pr-0.5" data-testid={`${testIdInit}-ust-nr-title`}>
            {t('impressum.ust_nr_title')}
          </span>
          <span data-testid={`${testIdInit}-ust-nr`}>
            {t('impressum.ust_nr')}
          </span>
        </div>
        <div>
          <span
            className="pr-0.5"
            data-testid={`${testIdInit}-executives-intro`}
          >
            {t('impressum.executives_intro')}
          </span>
          <span data-testid={`${testIdInit}-executives`}>
            {t('impressum.executives')}
          </span>
        </div>
        <div className="flex flex-col">
          <span data-testid={`${testIdInit}-responsibility-title`}>
            {t('impressum.responsibility_title')}
          </span>
          <span data-testid={`${testIdInit}-responsibility`}>
            {t('impressum.responsibility')}
          </span>
        </div>
      </div>
    </div>
  )
}
